/**
 * Translation hook for Lobby2.0
 * Manages translation loading and language changes
 */

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../store/app/appStore';
import TranslationService from '../../core/services/i18n/TranslationService';

export const useTranslations = () => {
  const { i18n } = useTranslation();
  const languageCode = useAppStore((state) => state.settings.languageCode);
  const assetsHost = useAppStore((state) => state.settings.assetsHost);
  const assetsHash = useAppStore((state) => state.settings.assetsHash);
  const settingsRequestDone = useAppStore((state) => state.settingsRequestDone);
  
  // Note: Initial translation loading now happens in useInitializeLobby before settingsRequestDone
  // This hook only handles language changes after initial load
  
  // Handle language changes
  useEffect(() => {
    if (settingsRequestDone && languageCode && assetsHost) {
      // For CDN environments, wait for assetsHash to be available
      if (assetsHost.includes('cdn') && (!assetsHash || assetsHash === '')) {
        // Skip language change - will retry when assetsHash is available
        return;
      }

      // Only change if it's different from current language
      const currentLang = i18n.language?.toLowerCase();
      const targetLang = languageCode.toLowerCase();

      if (currentLang !== targetLang) {
        TranslationService.changeLanguage(languageCode, assetsHost, assetsHash);
      }
    }
  }, [languageCode, assetsHost, assetsHash, settingsRequestDone, i18n.language]);
  
  return {
    currentLanguage: i18n.language,
    isReady: settingsRequestDone,
  };
};

// Convenience hook for getting the translate function
export const useTranslator = () => {
  const { t } = useTranslation();
  return t;
};